import { useEffect } from 'react'
import { AvailyEvent } from '@customTypes/Availy'
import { Config } from '@customTypes/Config'
import { AppMode } from '@customTypes/Generic'
import { useSurveyContext } from '@context/SurveyContext'
import { useVisibilityContext } from '@context/VisibilityContext'
import { postParentMsg } from 'src/utils/postMessage'
import logToPostHog from 'src/helpers/logToPosthog'

interface PatientSurveyProps {
  setAppMode: (mode: AppMode) => void
  initialConfig: Config
}

const delayInSeconds = 1

const usePatientSurvey = ({ setAppMode, initialConfig }: PatientSurveyProps) => {
  const { shouldOpenSurvey, surveyCompleted, setShouldOpenSurvey } = useSurveyContext()
  const { setIsVisible } = useVisibilityContext()
  useEffect(() => {
    if (shouldOpenSurvey && !surveyCompleted) {
      setTimeout(() => {
        postParentMsg({ type: AvailyEvent.OPEN_MODAL })
        setIsVisible?.(true)
        setAppMode(AppMode.SURVEY)
        logToPostHog('Gap filler runaway - form displayed')
      }, delayInSeconds * 1000)
    }
    return () => {
      setAppMode(initialConfig.mode)
      setShouldOpenSurvey(false)
    }
  }, [shouldOpenSurvey, surveyCompleted, initialConfig.mode, setAppMode, setIsVisible, setShouldOpenSurvey])
}

export default usePatientSurvey
